/**
 * 
 * @param {*} subdomain 
 * @returns 
 */
const config = (subdomain) => {

    // Most deploy does not support subdomains
    return {
        logo: "/loga/title/zastupko/small.svg",
    };
}
export default config;